import React, { FC } from 'react';
import { Typography } from '../Typography';
import { List } from '../List';
import { PrimaryButton } from '../Button';
import { styled } from '../../styles';
import { useIntlBds } from '../../translations/BdsIntlProvider';
import { Box } from '../Box';
import { BpDesignSystem } from '../../types';

export type NotificationListProps = BpDesignSystem.PropsWithChildren<{
  listHeight?: number;
  onMarkAllRead?: () => void;
  unReadCount: number;
  title?: string;
  customElement?: JSX.Element;
}>;

export const NotificationList: FC<NotificationListProps> = ({
  listHeight,
  onMarkAllRead,
  unReadCount,
  children,
  title,
  customElement,
  ...props
}) => {
  const { intl } = useIntlBds();

  return (
    <StyledContainer component="div" dataTest="notification-list" className="notification-list-container" {...props}>
      <StyledToolbar>
        {title && <Typography variant="h4">{title}</Typography>}
        <StyledFloatRight>
          {customElement}
          {unReadCount && onMarkAllRead ? (
            <PrimaryButton.Text dataTest="button" onClick={onMarkAllRead}>
              {intl.Notification.markAllReadButtonLabel}
            </PrimaryButton.Text>
          ) : null}
        </StyledFloatRight>
      </StyledToolbar>
      <List style={{ overflowY: 'auto', overflowX: 'visible', maxHeight: listHeight, padding: 0 }}>{children}</List>
    </StyledContainer>
  );
};

const StyledContainer = styled(Box)`
  width: 100%;
`;

const StyledFloatRight = styled('div')`
  margin-left: auto !important;
`;

const StyledToolbar = styled('div')`
  display: flex;
  align-items: center;
  padding: 16px;
`;
